import { render } from "./UTIPanelTestSelection.vue?vue&type=template&id=1038d6d0"
import script from "./UTIPanelTestSelection.vue?vue&type=script&lang=js"
export * from "./UTIPanelTestSelection.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/testSelection/UTIPanelTestSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1038d6d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1038d6d0', __exports__)) {
    console.log('reload')
    api.reload('1038d6d0', __exports__)
  }
  
  module.hot.accept("./UTIPanelTestSelection.vue?vue&type=template&id=1038d6d0", () => {
    console.log('re-render')
    api.rerender('1038d6d0', render)
  })

}


export default __exports__